import api from './api';

const revenueForecastService = {
  getRevenueForecast: async (params = {}) => {
    const response = await api.get('/main-dashboard/revenue-forecast', { params });
    return response.data;
  }
};

export default revenueForecastService;
